<template>
    <b-container v-if="isLoaded" fluid class="p-0 overflow-auto" style="height: 100vh">
        <b-row class="justify-content-between h-100" style="" no-gutters>
            <b-col v-if="!hideCarousel" md="5" style="background-color:#4129A8;">
                <carousel></carousel>
            </b-col>
            <b-col :md="hideCarousel ? 12 : 7" class="form-side d-flex justify-content-center align-items-center " style="background-color:#fff;" >
                <b-container style="border:none;background-color:#fff;color:#022B49;margin:auto;width:50%">
                    <b-row class="mb-5" style="font-weight: bold; font-size: 1.75em;">
                        <b-col>
                            <span style="text-align: center;">
                                    {{$t('signUp')}}
                            </span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col class="input-box">
                            <b-input-group class="signup-input-group">
                                <b-input-group-prepend is-text>
                                    <img src="../../assets/icon/firstName_icon.svg"/>
                                </b-input-group-prepend>
                                <b-form-input v-model="user.firstName" :placeholder="$t('firstNamePlaceholder')" type="text" :class="['input-field', {'is-invalid': errors.firstName }]" required/>
                            </b-input-group>
                            <span v-if="errors.firstName" class="validation-error">{{$t('firstNameValidationError')}}</span>
                        </b-col>
                        <b-col class="signup-input-group">
                            <b-form-input v-model="user.lastName" :placeholder="$t('lastNamePlaceholder')" type="text" :class="['input-field', {'is-invalid': errors.lastName }]" required/>
                            <span v-if="errors.lastName" class="validation-error">{{$t('lastNameValidationError')}}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3">
                            <b-input-group class="signup-input-group">
                                <b-input-group-prepend is-text>
                                    <img src="../../assets/icon/mail_icon.svg"/>
                                </b-input-group-prepend>
                                <b-form-input disabled v-model="user.email" type="text" class="input-field" required/>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3">
                            <b-input-group class="signup-input-group">
                                <b-input-group-prepend is-text>
                                    <img src="../../assets/icon/department_icon.svg"/>
                                </b-input-group-prepend>
                                <b-form-input v-model="user.department" :placeholder="$t('departmentPlaceholder')" type="text" class="input-field"/>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3">
                            <b-input-group class="signup-input-group">
                                <b-input-group-prepend is-text>
                                    <img src="../../assets/icon/title_icon.svg"/>
                                </b-input-group-prepend>
                                <b-form-input v-model="user.jobTitle" :placeholder="$t('jobTitlePlaceholder')" type="text" class="input-field"/>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <img src="../../assets/icon/password_icon.svg"/>
                                </b-input-group-prepend>
                                <div class="placeholder-wrap">
                                    <b-form-input v-model="user.password" type="password" id="password"
                                    :class="['input-field', {'is-invalid': errors.password }]"
                                    required/>
                                    <span class="placeholder">
                                        {{$t('passwordPlaceholder')}} <span class="password-info">({{$t('passwordInfo')}})</span>
                                    </span>
                                </div>
                                <b-input-group-append style="background-color:#EFEDF5 !important;" is-text>
                                    <span v-if="showPassword" @click="switchPasswordVisibility('password')" key="password-visible">
                                        <!--<i class="fas fa-eye" style="color:#7c7c7c;cursor:pointer;"></i>-->
                                        <img src="../../assets/icon/showPassword_icon.svg" key="showPass"><img>
                                    </span>
                                    <span v-else @click="switchPasswordVisibility('password')" key="password-invisible">
                                        <!--<i class="fas fa-eye-slash" style="color:#7c7c7c;cursor:pointer;"></i>-->
                                        <img src="../../assets/icon/hidePassword_icon.svg" key="hidePass"><img>
                                    </span>
                                </b-input-group-append>
                            </b-input-group>
                            <span v-show="errors.password" class="validation-error">{{$t(passwordErrorType)}}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-3">
                            <b-input-group class="signup-input-group">
                                <b-input-group-prepend is-text>
                                    <img src="../../assets/icon/password_icon.svg"/>
                                </b-input-group-prepend>
                                <b-form-input v-model="user.passwordConfirmation" :placeholder="$t('confirmPasswordPlaceholder')" type="password" id="passwordConfirmation"
                                :class="['input-field', {'is-invalid': errors.password }]" required/>
                                <b-input-group-append is-text>
                                    <span v-if="showPasswordConfirmation" @click="switchPasswordVisibility('passwordConfirmation')" key="password-confirmation-visible">
                                        <!--<i class="fas fa-eye" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                        <img src="../../assets/icon/showPassword_icon.svg" key="showConfirmPass"><img>
                                    </span>
                                    <span v-else @click="switchPasswordVisibility('passwordConfirmation')" key="password-confirmation-invisible">
                                        <!--<i class="fas fa-eye-slash" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                        <img src="../../assets/icon/hidePassword_icon.svg" key="hideConfirmPass"><img>
                                    </span>
                                </b-input-group-append>
                            </b-input-group>
                            <span v-show="errors.password && passwordErrorType == 'passwordsDoNotMatch'" class="validation-error">{{$t(passwordErrorType)}}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-checkbox
                            v-model="selectedPrivacyPolicy"
                            :value="true"
                            :unchecked-value="false"
                            :class="{'checkbox-invalid': errors.checkbox}"
                            >
                            <span style="font-size:1rem;">{{$t('termsPart-1')}} <a href=# class="underline-link">{{$t('termsPart-2')}}</a> {{$t('termsPart-3')}} <a href=# class="underline-link">{{$t('termsPart-4')}}</a> {{$t('termsPart-5')}}.</span>
                            </b-form-checkbox>
                            <span v-if="errors.checkbox" class="validation-error">{{$t('canNotLeaveEmpty')}}</span>
                        </b-col>
                    </b-row>
                    <b-row> 
                        <b-col class="mt-5">
                            <b-button @click="register()" class="w-35 light-green" >{{ $t('register') }}</b-button>
                        </b-col>
                    </b-row>
                    <b-row> 
                        <b-col class="mt-3">
                            <span>{{$t('alreadyHaveAccount')}} <router-link :to="{name: 'login'}" class="underline-link">{{$t('signIn')}}</router-link></span>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import api from '../../api';
import Carousel from '../../components/Carousel.vue';
import _ from 'lodash';
export default {
    components: { Carousel },
    name: 'Register',
    data() {
        return {
            user: {
                id: null,
                email: null,
                firstName: null,
                lastName: null,
                jobTitle: null,
                department: null,
                inviteUUID: null,
                password: null,
                passwordConfirmation: null,
            },
            title: 'Carbon Intelligence',
            isLoaded: false,
            selectedPrivacyPolicy: false,
            uuid: null,
            showPassword: false,
            showPasswordConfirmation: false,
            passwordErrorType: null,
            hideCarousel: false,
            errors: {
                firstName: false,
                lastName: false,
                password: false,
                checkbox: false
            },
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        };
    },
    methods: {
        register() {
            if(this.isValid()){
                this.$Progress.start();
                this.axios
                    .post('/user/create', {
                        user: this.user
                    })
                    .then(response => {
                        localStorage.setItem('token', response.data.token);
                        document.cookie = `Authorization=Bearer ${response.data.token}`;
                        this.axios.defaults.headers.Authorization = response.data.token
                            ? `Bearer ${response.data.token}`
                            : 'Bearer ';
                        this.$Progress.finish();
                        location.href = location.origin;
                    })
                    .catch(() => {
                        this.$Progress.fail();
                });
            }
        },
        isValid(){
            this.errors.firstName = !this.user.firstName;
            this.errors.lastName = !this.user.lastName;
            this.errors.checkbox = !this.selectedPrivacyPolicy;

            this.errors.password = !this.user.password;
            this.passwordErrorType = this.errors.password ? 'passwordEmptyValidationError' : null;
            if(!this.errors.password) {
                this.errors.password = !this.isPasswordValid(this.user.password) || this.user.password.length < 7;
                this.passwordErrorType = 'passwordNotValidError';
            }
            if(!this.errors.password) {
                this.errors.password = !this.isPasswordsMatch(this.user.password, this.user.passwordConfirmation);
                this.passwordErrorType = 'passwordsDoNotMatch';
            }
            
            let validation = true;
            for (let key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        isPasswordValid(password){
            if(password){
                return this.user.password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/);
            } 
        },
        isPasswordsMatch(password, passwordConfirmation){
            return _.isEqual(password, passwordConfirmation);
        },
        switchPasswordVisibility(id){
            id == 'password' ? this.showPassword=!this.showPassword : this.showPasswordConfirmation=!this.showPasswordConfirmation;
            const passwordField = document.querySelector('#'+id);
            if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text')
            else passwordField.setAttribute('type', 'password')
        },
        init(){
            return this.axios.get(`/user/invite/${this.uuid}`).then(({data}) => {
                if(data.response.status != 'invited'){
                    this.$router.push({path: '/login', query:{inviteCanceled:true}});
                }
                else{
                    this.user.id = data.response.id;
                    this.user.email = data.response.email;
                    this.user.inviteUUID = this.uuid;
                    this.isLoaded = true;
                }
            });
        },
        onResize(){
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created() {
        this.onResize();
        this.uuid = this.route.query.uuid;
        this.init();
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.title = 'titleGaranti';
            this.hideCarousel = true;
        }
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.onResize);
    },
    beforeRouteEnter(to, from, next) {
        if (!to.query.uuid) {
            next('/login');
        } else {
            api
                .get(`/user/invite/${to.query.uuid}`)
                .then(() => {
                    next();
                })
                .catch(() => {
                    next('/login');
                });
        }
    }
};
</script>

<style lang="scss">
// .carousel-side, .form-side {
//     height: 100vh;
//     width: 100%;
// }
.signup-input-group .input-field {
    background-color: #EFEDF5 !important;
    color: #022B49 !important;
    font-size: 1em;
}
.signup-input-group .input-field::placeholder {
    color : #A0A0A0 !important;
}
.signup-input-group .input-field:focus {
    outline: none !important;
    border:1px solid #8276c3 !important;
    box-shadow: none !important;
}

.validation-error {
    color: #F14079;
    float: left;
    font-size: .7em;
}
.is-invalid {
    border-color: #F14079 !important;
}
.checkbox-invalid {
    .custom-control-label:before{
        border: 1.5px solid #F14079;
    }
}
.underline-link {
    color: #D118A8 !important;
    text-decoration: underline;
    font-weight: bold;
}
.form-side .input-group-prepend .input-group-text {
  background-color: #EFEDF5 !important;
}
.form-side .input-group-append .input-group-text {
  background-color: #EFEDF5 !important;
}

.light-green {
    background-color: #49DC9B !important;
    font-weight: bold !important;
    border: none !important;
}

.placeholder-wrap {
    display: inline-block;
    position: relative;
    background: #EFEDF5;
    overflow: hidden;
    flex: 1 1 auto;
    width: 1%;
}
.placeholder-wrap .placeholder {
    position: absolute;
    top: 50%;
    left: 15px;
    color: #A0A0A0;
    margin-top: -.5em;
    line-height: 1em;
    z-index: 9;
    overflow: hidden;
    white-space: nowrap;
}
.placeholder-wrap input {
    color: #022B49 !important;
    font-size: 1em;
    background-color: transparent;
    border-radius: 0;
    position: relative;
    z-index: 10;
}
.placeholder-wrap input:focus {
    outline: none !important;
    border:1px solid #8276c3 !important;
    box-shadow: none !important;
    background: #EFEDF5;
}

.placeholder-wrap input:focus + .placeholder,
.placeholder-wrap input[required]:valid + .placeholder,
.placeholder-wrap input.not-empty + .placeholder {
    display: none;
}

.placeholder span {
  color: #A0A0A0;
  font-size: .7em;
}


@media only screen and (max-width:780px) {
    // .carousel-side, .form-side {
    //     height: 100vh;
    //     width: 100%
    // }
    .placeholder span {
        color: #A0A0A0;
        font-size: .6em;
    }
}

</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "firstNamePlaceholder": "Ad",
            "lastNamePlaceholder": "Soyad",
            "emailPlaceholder": "E-posta",
            "departmentPlaceholder": "Departman",
            "jobTitlePlaceholder": "Ünvan",
            "passwordPlaceholder": "Şifre",
            "passwordInfo": "7+ karakter ve bir rakam",
            "confirmPasswordPlaceholder": "Şifre Tekrar",
            "register": "Hesap Oluştur",
            "inviteCanceled": "Bu davet artık geçerli değil",
            "alreadyHaveAccount": "Zaten hesabınız var mı?",
            "termsPart-1": "Kaydolarak",
            "termsPart-2": "Kullanım Koşullarımızı",
            "termsPart-3": "ve",
            "termsPart-4": "Gizlilik Politikamızı",
            "termsPart-5": "kabul etmiş olursunuz",
            "signUp": "Kayıt Ol",
            "signIn": "Giriş Yap",
            "firstNameValidationError": "Lütfen adınızı girin",
            "lastNameValidationError": "Lütfen soyadınızı girin",
            "passwordEmptyValidationError": "Lütfen bir şifre girin",
            "passwordLengthError": "En az 7 karakter içermeli",
            "passwordNotValidError": "En az bir karakter ve bir rakam içermeli",
            "passwordsDoNotMatch": "Şfireler uyuşmuyor",
            "canNotLeaveEmpty": "Hesap oluşturabilmeniz için kullanım koşulları ve gizlilik politikasını kabul etmeniz gerekir."
        },
        "en": {
            "firstNamePlaceholder": "Name",
            "lastNamePlaceholder": "Surname",
            "emailPlaceholder": "E-mail",
            "departmentPlaceholder": "Department",
            "jobTitlePlaceholder": "Title",
            "passwordPlaceholder": "Password",
            "passwordInfo": "7+ characters and one number",
            "confirmPasswordPlaceholder": "Confirm Password",
            "register": "Create Account",
            "inviteCanceled": "This invitation no longer available",
            "alreadyHaveAccount": "Already have an Account?",
            "termsPart-1": "By creating an account you agree to the",
            "termsPart-2": "terms of use",
            "termsPart-3": "and our",
            "termsPart-4": "privacy policy",
            "termsPart-5": " ",
            "signUp": "Sign Up",
            "signIn": "Sign In",
            "firstNameValidationError": "Please enter your first name",
            "lastNameValidationError": "Please enter your last name",
            "passwordEmptyValidationError": "Please enter a password",
            "passwordLengthError": "Must contain at least 7 characters",
            "passwordNotValidError": "Must contain at least 7 characters and 1 number",
            "passwordsDoNotMatch": "Passwords do not match",
            "canNotLeaveEmpty": "Before you can create an account, you must accept the terms of use and privacy policy."
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Register/Register.vue